import React, { useContext, useEffect, useState } from 'react';
import { DataContext } from "../context/DataContext";
import { upload_excel_data_admin_api } from '../controllers/dataController';
import CircularProgress from '@mui/material/CircularProgress';
import {Button} from "./custom_ui/button.tsx";

const UploadFilePopup = ({ isOpen, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [upload_response, setUploadResponse] = useState(null);
    const [fileName, setFileName] = useState('');
    if (!isOpen) return null;

    const handle_close = () => {
        setUploadResponse(null);
        setLoading(false);
        setFile(null);
        onClose();
    }

    const onChangeHandler = (event) => {
        handleFileChange(event);
        if (event.target.files && event.target.files.length > 0) {
            setFileName(event.target.files[0].name);
        } else {
            setFileName('');
        }
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFile(file);
        if (file) {
            console.log("Selected file:", file);
        }
    }


    const handleUpload = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (file) {
            const response = await upload_excel_data_admin_api(file);
            console.log("Upload response:", response.data.valid_records);
            setUploadResponse(response.data);
        }
        setLoading(false);
    };

    return (
        <div className="fixed inset-0  flex items-center h-full justify-center z-50">
            <div className='fixed z-[-1] inset-0 bg-gray-900 opacity-70' onClick={onClose}></div>

            <div className="relative bg-gray-800 rounded-lg shadow-lg p-6 overflow-y-auto w-full h-full max-h-100 max-w-md mx-auto ">
                <button
                    onClick={handle_close}
                    className="absolute top-3 right-3 text-gray-400 hover:text-white transition-colors"
                >
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <h2 className="text-xl font-bold text-white mb-4">Upload Excel Data File</h2>
                <form
                    encType="multipart/form-data"
                    method="POST"
                >
                    <div className='flex justify-between items-center'>
                    <div className='flex items-center gap-4 mt-4'>
                    <label
                        htmlFor="excel-file-upload"
                        className="
                            px-4 py-2 
                            text-base font-semibold 
                            text-white 
                            bg-gray-700
                            rounded-lg 
                            shadow-md 
                            cursor-pointer 
                            transition duration-200 
                            hover:bg-secondary
                            active:bg-secondary-dark
                            focus:outline-none focus:ring-2 focus:gold focus:ring-offset-2"
                            >
                        Choose Excel File
                    </label>
                    <input
                        id="excel-file-upload" // Link ID
                        type="file"
                        name="excel_file"
                        accept=".xlsx, .xls"
                        required
                        onChange={onChangeHandler}
                        className="sr-only "
                    />
                    <span className={`text-sm ${fileName ? 'text-gray-200' : 'text-gray-500'}`}>
                        {fileName ? fileName : "No file selected"}
                    </span>
                    </div>
                    {loading ? <p className="text-white"><CircularProgress></CircularProgress></p> :
                        <Button disabled={loading} type="submit" onClick={handleUpload} className="mt-4 text-white py-2 px-4 rounded-lg">
                            Upload
                        </Button>}
</div>
                </form>

                <div className="mt-4">
                    {(upload_response && upload_response.valid_records) ?
                        <div className="text-green-500">
                            <p>Upload Successful!</p>
                            {upload_response.valid_records.map((record, index) => (
                                <p key={index}>{record}</p>
                            ))
                            }
                        </div>
                        : ""
                    }
                </div>
            </div>
        </div>
    );
};

export default UploadFilePopup;